/** bbox [x1,y1,x2,y2] 선형 보간 */
export function lerpBbox(
  from: number[],
  to: number[],
  t: number
): number[] {
  const k = Math.max(0, Math.min(1, t));
  return [
    from[0] + (to[0] - from[0]) * k,
    from[1] + (to[1] - from[1]) * k,
    from[2] + (to[2] - from[2]) * k,
    from[3] + (to[3] - from[3]) * k,
  ];
}

export function bboxDeltaMax(from: number[], to: number[]): number {
  return Math.max(
    Math.abs(from[0] - to[0]),
    Math.abs(from[1] - to[1]),
    Math.abs(from[2] - to[2]),
    Math.abs(from[3] - to[3])
  );
}
